import { Component, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import { AbstractControl } from "@angular/forms";
import { PlacardEditionRequest } from "../../../api/models/placardEdit";
import { ApiErrorCode, CommonConstants, ServiceURLConstants } from "../../../constants/upplm.constants";
import { DAY_OF_WEEK, LAPSE_TIME_INCREMENT, PICKUP_TYPE, PICKUP_TYPE_PLAN, PICKUP_TYPE_TEXT_MESSAGE, SCHEDULE_ERROR_MESSAGES, SMART_PICKUP_NOTE } from "../../../constants/upplm.constants.pickupdetails";
import { AvailableDayAndService, ErrorSchedule, GenericSchedule, PickupScheduleDetailResponse, PickupType, ScheduleListDDL } from "../../../interface/upplm.pickupdetails";
import { SelectedDays } from "../../../interface/upplm.placardInformation";
import { TranslateDataPipe } from "../../../pipes/translation.pipe";
import { PickupDetailsHelperService } from "../../../services/PlacardEditionServices/upplm.pickupDetailsHelper.service";
import { UpplmApiService } from "../../../services/upplm.api.services";
import { UpsCommonService } from "../../../services/upplm.common.service";
import { StoredDataService } from "../../../services/upplm.storedData.service";
import { UpsDialogComponent } from "../../commonComponent/ups-dialog/ups-dialog.component";

@Component({
    selector: 'editpickupdetails',
    template: require('./editPickupDetails.component.html'),
    styles: ['.errorTimeMessage{float: right;padding-left: 21px;padding-right: 30px;top: -10px;}'],
    providers: [PickupDetailsHelperService]
})

export class EditPickupDetailsComponent implements OnInit {

    pickupTypeClass: string = 'ups-dropdown ng-touched ng-dirty ng-valid';
    isInitialLoading: boolean = true;
    pickupTypeSelectedValue: string = '-1';
    Errors: ErrorSchedule[] = [];
    pickupPlanTypes: PickupType[];
    availableDaysAndServices: AvailableDayAndService[] = [];
    pickupTypeDescription: string = '';
    includeSaturdayInPickup: boolean = false; // Indicates if Saturday would be included, in case is available
    allSchedule: GenericSchedule[] = [];
    isSaturdayAvailable: boolean = false; // Indicates if a service on Saturday is Available for the location
    validationSelectDapSmp: boolean = false;
    textSmartMessagePickupFooter: string = SMART_PICKUP_NOTE;
    showNotificationChanges: boolean = false;
    showEditPickupDetails: boolean = true;
    @ViewChild('errorServerMessage', { static: false }) errorServerMessage: UpsDialogComponent;
    messagesErrorServer: string = '';
    reviewScheduleNote: boolean = false;
    @Output() hideEditSection = new EventEmitter<boolean>();
    globalRegioForShowTimes: string = 'NA';
    globalRegionCountry: string = 'NA'
    countryCode: string = 'US';

    constructor(private _storedDataService: StoredDataService,
        private _pickupDetailsHelperService: PickupDetailsHelperService,
        private _translate: TranslateDataPipe,
        private _commonService: UpsCommonService,
        private _apiService: UpplmApiService) {

    }

    ngOnInit(): void {
        this.isInitialLoading = true;
        if (this._storedDataService.pickupDetails.pickupComesFromLocation) {
            this.prepareInitialDataFromSource(this._storedDataService.pickupDetails.pickupScheduleDetailResponse);
            this.reviewScheduleNote = true;
        } else {
            let request = this._pickupDetailsHelperService.getPickupScheduleDetailsRequest(this._storedDataService.locationDetails);
            let url = this._commonService.createURL(ServiceURLConstants.GET_UPPLM_PICKUP_DETAILS, ApiErrorCode.GET_UPPLM_PICKUP_DETAILS);
            this._apiService.PostServiceAPI(url, request).subscribe((response: PickupScheduleDetailResponse) => {
                this.prepareInitialDataFromSource(response);
            });
        }
        this.isInitialLoading = false;
    }

    prepareInitialDataFromSource(pickupScheduleDetailResponse: PickupScheduleDetailResponse) {
        this.globalRegioForShowTimes = this._storedDataService.globalRegionForShowTimes;
        this.globalRegionCountry = this._storedDataService.globalRegionForShowTimes;
        this.countryCode = this._storedDataService.countryCode;
        this.availableDaysAndServices = pickupScheduleDetailResponse.availableDaysAndServices;
        this.pickupPlanTypes = this._pickupDetailsHelperService.getPickupTypeDescription(pickupScheduleDetailResponse.pickupPlanTypes);
        this.isSaturdayAvailable = this.hasSaturday(pickupScheduleDetailResponse.availableDaysAndServices);
        this.includeSaturdayInPickup = this._storedDataService.pickupDetails.selectedDays.some(x => x.dayOfWeekCode === DAY_OF_WEEK.SATURDAY);
        this.processInitialPickupType(this.getPickupType(this._storedDataService.pickupDetails.pickupComesFromLocation));
        this.changePickupType(this.pickupTypeSelectedValue);
        this.fillOptionsDropdown();
    }

    getPickupType(comesFromLocation: boolean): string {
        if (comesFromLocation) return this._storedDataService.pickupDetails.pickupType;
        return this._pickupDetailsHelperService.getPickupTypeSelection(this._storedDataService.pickupDetails.pickupType);
    }

    processInitialPickupType(pickupType: string) {
        if (!this.pickupPlanTypes.some(planType => planType.id === pickupType)) {
            this.pickupTypeSelectedValue = '-1';
            this.pickupTypeDescription = this._translate.transform("upplm.common.selectone");
        } else {
            this.pickupTypeSelectedValue = pickupType;
            this.pickupTypeDescription = this._translate.transform(PICKUP_TYPE_PLAN.find(x => x.id === pickupType).translatedDescription.toString());
        }
    }

    fillOptionsDropdown() {
        if (this.pickupTypeSelectedValue !== '-1') {
            var validationResultOfPreferredTimeSelected = false;
            var validationResultOfLatestTimeSelected = false;
            var selectedDays = this._storedDataService.pickupDetails.selectedDays;
            this.allSchedule.forEach(timeRangesPerDayFromApi => {
                if (timeRangesPerDayFromApi.dayOfWeekCode == "02") {
                    selectedDays.forEach(timeRangesSelectedPerDay => {
                        if (timeRangesSelectedPerDay.dayOfWeekCode.toUpperCase() == "MON") {
                            validationResultOfPreferredTimeSelected = this.validatePreferredTimeSelected(timeRangesPerDayFromApi, timeRangesSelectedPerDay);
                            validationResultOfLatestTimeSelected = this.validateLatestTimeSelected(timeRangesPerDayFromApi, timeRangesSelectedPerDay);
                            if (validationResultOfPreferredTimeSelected == true && validationResultOfLatestTimeSelected) {
                                timeRangesSelectedPerDay = this.getValuesToFillDropdownsSelectedPreferredTime(timeRangesSelectedPerDay);
                                timeRangesPerDayFromApi.preferredSelected = this.validatePM(timeRangesSelectedPerDay.selectedPreferredTime);
                                timeRangesPerDayFromApi.latestSelected = this.validatePM(timeRangesSelectedPerDay.selectedLatestTime);
                                timeRangesPerDayFromApi.selectedDay = true;
                            }
                        }
                    });
                } else if (timeRangesPerDayFromApi.dayOfWeekCode == "03") {
                    selectedDays.forEach(y => {
                        if (y.dayOfWeekCode.toUpperCase() == "TUE") {
                            validationResultOfPreferredTimeSelected = this.validatePreferredTimeSelected(timeRangesPerDayFromApi, y);
                            validationResultOfLatestTimeSelected = this.validateLatestTimeSelected(timeRangesPerDayFromApi, y);
                            if (validationResultOfPreferredTimeSelected == true && validationResultOfLatestTimeSelected) {
                                y = this.getValuesToFillDropdownsSelectedPreferredTime(y);
                                timeRangesPerDayFromApi.preferredSelected = this.validatePM(y.selectedPreferredTime);
                                timeRangesPerDayFromApi.latestSelected = this.validatePM(y.selectedLatestTime);
                                timeRangesPerDayFromApi.selectedDay = true;
                            }
                        }
                    });
                } else if (timeRangesPerDayFromApi.dayOfWeekCode == "04") {
                    selectedDays.forEach(y => {
                        if (y.dayOfWeekCode.toUpperCase() == "WED") {
                            validationResultOfPreferredTimeSelected = this.validatePreferredTimeSelected(timeRangesPerDayFromApi, y);
                            validationResultOfLatestTimeSelected = this.validateLatestTimeSelected(timeRangesPerDayFromApi, y);
                            if (validationResultOfPreferredTimeSelected == true && validationResultOfLatestTimeSelected) {
                                y = this.getValuesToFillDropdownsSelectedPreferredTime(y);
                                timeRangesPerDayFromApi.preferredSelected = this.validatePM(y.selectedPreferredTime);
                                timeRangesPerDayFromApi.latestSelected = this.validatePM(y.selectedLatestTime);
                                timeRangesPerDayFromApi.selectedDay = true;
                            }
                        }
                    });
                } else if (timeRangesPerDayFromApi.dayOfWeekCode == "05") {
                    selectedDays.forEach(y => {
                        if (y.dayOfWeekCode.toUpperCase() == "THU") {
                            validationResultOfPreferredTimeSelected = this.validatePreferredTimeSelected(timeRangesPerDayFromApi, y);
                            validationResultOfLatestTimeSelected = this.validateLatestTimeSelected(timeRangesPerDayFromApi, y);
                            if (validationResultOfPreferredTimeSelected == true && validationResultOfLatestTimeSelected) {
                                y = this.getValuesToFillDropdownsSelectedPreferredTime(y);
                                timeRangesPerDayFromApi.preferredSelected = this.validatePM(y.selectedPreferredTime);
                                timeRangesPerDayFromApi.latestSelected = this.validatePM(y.selectedLatestTime);
                                timeRangesPerDayFromApi.selectedDay = true;
                            }
                        }
                    });
                } else if (timeRangesPerDayFromApi.dayOfWeekCode == "06") {
                    selectedDays.forEach(y => {
                        if (y.dayOfWeekCode.toUpperCase() == "FRI") {
                            validationResultOfPreferredTimeSelected = this.validatePreferredTimeSelected(timeRangesPerDayFromApi, y);
                            validationResultOfLatestTimeSelected = this.validateLatestTimeSelected(timeRangesPerDayFromApi, y);
                            if (validationResultOfPreferredTimeSelected == true && validationResultOfLatestTimeSelected) {
                                y = this.getValuesToFillDropdownsSelectedPreferredTime(y);
                                timeRangesPerDayFromApi.preferredSelected = this.validatePM(y.selectedPreferredTime);
                                timeRangesPerDayFromApi.latestSelected = this.validatePM(y.selectedLatestTime);
                                timeRangesPerDayFromApi.selectedDay = true;
                            }
                        }
                    });
                } else if (timeRangesPerDayFromApi.dayOfWeekCode == "07") {
                    selectedDays.forEach(y => {
                        if (y.dayOfWeekCode.toUpperCase() == "SAT") {
                            validationResultOfPreferredTimeSelected = this.validatePreferredTimeSelected(timeRangesPerDayFromApi, y);
                            validationResultOfLatestTimeSelected = this.validateLatestTimeSelected(timeRangesPerDayFromApi, y);
                            if (validationResultOfPreferredTimeSelected == true && validationResultOfLatestTimeSelected) {
                                y = this.getValuesToFillDropdownsSelectedPreferredTime(y);
                                timeRangesPerDayFromApi.preferredSelected = this.validatePM(y.selectedPreferredTime);
                                timeRangesPerDayFromApi.latestSelected = this.validatePM(y.selectedLatestTime);
                                timeRangesPerDayFromApi.selectedDay = true;
                            }
                        }
                    });
                }
            })
        }
    }

    validatePreferredTimeSelected(timeRangesPerDayFromApi: GenericSchedule, timeRangesPerDaySelected: any) {
        let firstPreferredTimeAllowed = parseInt(timeRangesPerDayFromApi.preferredTime[0].unformattedTime);
        let selectedPreferredTimeSplitted = [];
        let lastPreferredTimeAllowed = parseInt(timeRangesPerDayFromApi.preferredTime[timeRangesPerDayFromApi.preferredTime.length - 1].unformattedTime);
        let selectedPreferredTime = 0;
        if (timeRangesPerDaySelected.selectedPreferredTime.toUpperCase().includes("PM")) {
            let preferredTimeSelected = timeRangesPerDaySelected.selectedPreferredTime.substring(0, timeRangesPerDaySelected.selectedPreferredTime.length - 3);
            selectedPreferredTimeSplitted = preferredTimeSelected.split(":");
            let selectedPreferredTimeUnformatted = parseInt(selectedPreferredTimeSplitted[0]);
            if (selectedPreferredTimeUnformatted != 12) {
                selectedPreferredTime = selectedPreferredTimeUnformatted + 12;
            } else {
                selectedPreferredTime = selectedPreferredTimeUnformatted;
            }
        } else {
            selectedPreferredTime = parseInt(timeRangesPerDaySelected.selectedPreferredTime);
        }
        if (firstPreferredTimeAllowed <= selectedPreferredTime && selectedPreferredTime < lastPreferredTimeAllowed) {
            return true;
        } else if (selectedPreferredTime == lastPreferredTimeAllowed) {
            return this._pickupDetailsHelperService.areGreaterForMinutes(timeRangesPerDayFromApi.preferredTime[timeRangesPerDayFromApi.preferredTime.length - 1].formattedTime, timeRangesPerDaySelected.selectedPreferredTime);
        } else {
            return false;
        }
    }

    validateLatestTimeSelected(timeRangesPerDayFromApi: GenericSchedule, timeRangesPerDaySelected: any) {
        let firstLatestTimeAllowed = parseInt(timeRangesPerDayFromApi.latestTime[0].unformattedTime);
        let latestTimeSelectedSplitted = [];
        let latestTimeAllowed = parseInt(timeRangesPerDayFromApi.latestTime[timeRangesPerDayFromApi.latestTime.length - 1].unformattedTime);
        let selectedPreferredTime = 0;
        if (timeRangesPerDaySelected.selectedLatestTime.toUpperCase().includes("PM")) {
            let latestTimeSelected = timeRangesPerDaySelected.selectedLatestTime.substring(0, timeRangesPerDaySelected.selectedLatestTime.length - 3);
            latestTimeSelectedSplitted = latestTimeSelected.split(":");
            let latestTimeSelectedUnformatted = parseInt(latestTimeSelectedSplitted[0]);
            if (latestTimeSelectedUnformatted != 12) {
                selectedPreferredTime = latestTimeSelectedUnformatted + 12;
            } else {
                selectedPreferredTime = latestTimeSelectedUnformatted;
            }

        } else {
            selectedPreferredTime = parseInt(timeRangesPerDaySelected.selectedLatestTime);
        }
        if (firstLatestTimeAllowed <= selectedPreferredTime && selectedPreferredTime < latestTimeAllowed) {
            return true;
        } else if (selectedPreferredTime == latestTimeAllowed) {
            let minutesFromSelectedLatestTime = parseInt(latestTimeSelectedSplitted[1]);
            let unformattedLastLatestTimeAllowed = timeRangesPerDayFromApi.latestTime[timeRangesPerDayFromApi.latestTime.length - 1].unformattedTime;
            let unformattedLastLatestTimeAllowedSplitted = unformattedLastLatestTimeAllowed.split(":");
            let minutesFromLastLatestTimeAllowed = parseInt(unformattedLastLatestTimeAllowedSplitted[1]);
            if (minutesFromLastLatestTimeAllowed >= minutesFromSelectedLatestTime) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    getValuesToFillDropdownsSelectedPreferredTime(y) {
        y.selectedPreferredTime = this.validateIfContainZero(y.selectedPreferredTime);
        y.selectedLatestTime = this.validateIfContainZero(y.selectedLatestTime);
        return y;
    }

    validateIfContainZero(value) {
        if (value.charAt(0) == "0") {
            return value.substr(1);
        } else {
            return value;
        }
    }

    validatePM(valueCheck: string) {
        if (valueCheck.toLowerCase().includes("pm") == true) {
            let r = valueCheck.substring(0, valueCheck.length - 3);
            let res = r.split(":");
            let n = parseInt(res[0]);
            if (n != 12) {
                n = n + 12;
                return n + ":" + res[1];
            } else {
                return n + ":" + res[1];
            }
        } else {
            let originalHourAndMinute = valueCheck.substring(0, valueCheck.length - 3);
            let splittedTime = originalHourAndMinute.split(':');
            let hourValue = parseInt(splittedTime[0]);
            let formattedHourAndMinute = (hourValue < 10 ? `0${hourValue.toString()}:` : `${hourValue.toString()}:`).toString().concat(splittedTime[1]);
            return formattedHourAndMinute;
        }
    }

    cancel() {

        if (this._storedDataService.pickupDetails.pickupComesFromLocation) { //If arrives from Location, then return to previous
            this.hideEditSection.emit(false);
        } else {
            this._storedDataService.clearEditingSections();
            this.hideEditSection.emit(true);
        }
    }

    changePickupType(selectedValue: any) {
        this.Errors = [];
        this.pickupTypeSelectedValue = selectedValue;
        if (this.pickupTypeSelectedValue !== '-1') {
            this.pickupTypeDescription = this._translate.transform(PICKUP_TYPE_TEXT_MESSAGE.find(x => x.id === this.pickupTypeSelectedValue).translationKey.toString());

            // todo: Refactor
            if (this.pickupTypeSelectedValue === PICKUP_TYPE.DAP || this.pickupTypeSelectedValue === PICKUP_TYPE.SMP) {
                if (this.allSchedule !== undefined) {
                    if (this.allSchedule.length >= 0) {
                        this.validationSelectDapSmp = false;
                    }
                }
            }
            this.getSchedulesByPickupType(selectedValue, this.hasSaturday(this.availableDaysAndServices));
        } else {
            this.includeSaturdayInPickup = false;
        }
    }

    saveEdit() {
        if (!(typeof this.Errors !== 'undefined' && this.Errors.length > 0)) {
            this.Errors = [];
        }
        this.validatePage();
        if (this.Errors.length == 0) {
            this.prepareDataForSaving();
            this.showNotificationChanges = true;
            this.showEditPickupDetails = false;
        }
    }

    prepareDataForSaving() {
        let selectedDays: SelectedDays[] = [];
        this.allSchedule.forEach(schedule => {
            if (schedule.preferredSelected !== "-1" && schedule.latestSelected !== "-1") {
                let selectedDay = new SelectedDays();
                selectedDay.dayOfWeekCode = schedule.dayOfWeekCode;
                selectedDay.selectedPreferredTime = schedule.preferredSelected;
                selectedDay.selectedLatestTime = schedule.latestSelected;
                selectedDays.push(selectedDay);
            }
        });
        if (this._storedDataService.pickupDetails.pickupComesFromLocation) {
            this._storedDataService.requestEditedData.pickupPlanType = this.pickupTypeSelectedValue;
            this._storedDataService.requestEditedData.selectedDays = selectedDays;
        } else {
            let requestEditedData = new PlacardEditionRequest();
            requestEditedData.pickupPlanType = this.pickupTypeSelectedValue;
            requestEditedData.selectedDays = selectedDays;
            this._storedDataService.requestEditedData = requestEditedData;
        }
    }

    validatePage() {
        this.Errors = [];
        this.validatePickupTypeNeeded();
        if (this.pickupTypeSelectedValue == 'DSP') {
            this.validateDSP();
            this.Errors = this.removeDuplicates(this.Errors, 'message');
            this.validateBusinessDays();
        } else {
            if (typeof this.allSchedule !== 'undefined' && this.allSchedule.length > 0) {
                for (let i = 0; i <= this.allSchedule.length - 1; i++) {
                    this.validatePickupTime(i);
                }
            }
            this.Errors = this.removeDuplicates(this.Errors, 'message');
        }
        this.focusHandler();
    }

    focusHandler() {
        this.pickupTypeClass = this.pickupTypeSelectedValue != '-1' ? 'ups-dropdown ng-touched ng-dirty ng-valid' : 'ups-dropdown ng-touched ng-dirty ups-bodError ng-invalid';
    }

    validateBusinessDays() {
        let businessDays = this.allSchedule.filter(x => x.day !== CommonConstants.ORDERED_DAYS_OF_WEEK[5]);
        let selectedDays = businessDays.filter(x => x.selectedDay === true);
        if (selectedDays.length === 4) {
            businessDays.forEach(function (element) {
                if (element.selectedDay === false) {
                    element.isDisabled = true;
                    element.preferredSelected = '-1';
                    element.latestSelected = '-1';

                }
            });
        }
        else {
            businessDays.forEach(function (element) {
                element.isDisabled = false;
            });
        }
    }

    removeDuplicates(myArr, prop) {
        return myArr.filter((obj, pos, arr) => {
            return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
        });
    }

    validateDSP() {
        const validateDays = this.allSchedule.filter(x => x.selectedDay == true || x.latestSelected !== '-1' || x.preferredSelected !== '-1');
        if (validateDays.length > 0) {
            if (typeof this.allSchedule !== 'undefined' && this.allSchedule.length > 0) {
                for (let i = 0; i <= this.allSchedule.length - 1; i++) {
                    if (this.allSchedule[i].selectedDay || this.allSchedule[i].latestSelected !== '-1' || this.allSchedule[i].preferredSelected !== '-1') {
                        this.validatePickupTime(i);
                    } else {
                        this.allSchedule[i].error = new ErrorSchedule();
                    }
                }
            }
        } else {
            this.addPickupTypeGeneralError();
        }
    }

    addPickupTypeGeneralError() {
        let errorGeneral = new ErrorSchedule();
        errorGeneral.message = this._translate.transform('upplm.pickupdetails.error.picktype_general');
        errorGeneral.code = 'PICK_TYPE_GENERAL';
        errorGeneral.position = -2;
        this.Errors.push(errorGeneral);
        if (typeof this.allSchedule !== 'undefined' && this.allSchedule.length > 0) {
            for (let i = 0; i <= this.allSchedule.length - 1; i++) {
                this.allSchedule[i].error = new ErrorSchedule();
            }
        }
    }

    validatePickupTime(position) {
        let result = 0;

        switch (this.pickupTypeSelectedValue) {
            case "DSP":
                result = this.validateScheduleDSP(position);
                break;
            case "DAP":
            case "SMP":
                let preferred =
                    this.allSchedule[position].preferredSelected != "-1" ? "1" : "0";
                let latest =
                    this.allSchedule[position].latestSelected != "-1" ? "1" : "0";
                let option = preferred.concat(latest);

                if (option == "00") {
                    this.addToListError("SMP_DAP_3", position);
                } else if (option == "01") {
                    this.addToListError("SMP_DAP_1", position);
                } else if (option == "10"
                ) {
                    this.addToListError("SMP_DAP_2", position);
                } else {
                    if (typeof this.Errors != 'undefined') {
                        this.Errors = this.removeFixedErrors(position);
                    }

                    result = this.validateOneHourDifference(
                        this.allSchedule[position].preferredSelected,
                        this.allSchedule[position].latestSelected
                    );
                }
                break;
        }
        switch (result) {
            case 1:
                this.addToListError("SMP_DAP_5", position);
                break;
            case 2:
                this.addToListError("SMP_DAP_4", position);
                break;
        }
    }

    removeFixedErrors(value: number) {

        //Verify Error is not udenfined
        if (!(typeof this.Errors !== 'undefined' && this.Errors.length > 0)) {
            this.Errors = [];
        }

        this.allSchedule[value].error = new ErrorSchedule();
        return this.Errors.filter(function (elem) {
            return elem.position != value;
        });
    }

    addToListError(errorCode: string, position: number) {

        let error = new ErrorSchedule();
        error.message = this._translate.transform(SCHEDULE_ERROR_MESSAGES.find(err => err.code === errorCode).key);
        error.code = errorCode;
        error.position = position;

        let findExistingError;

        //Verify Error is not udenfined
        if (!(typeof this.Errors !== 'undefined' && this.Errors.length > 0)) {
            this.Errors = [];
        }

        //Verify if the error exists
        findExistingError = this.Errors.find(err => err.code === errorCode && err.position === error.position);

        //If no error code found in the list, then add to the error list
        if (!(typeof findExistingError !== 'undefined' && findExistingError.code.length > 0)) {
            this.Errors.push(error);
            this.allSchedule[position].error = error;
        }
    }

    ddToListError(errorCode: string, position: number) {

        let error = new ErrorSchedule();
        error.message = this._translate.transform(SCHEDULE_ERROR_MESSAGES.find(err => err.code === errorCode).key);
        error.code = errorCode;
        error.position = position;

        let findExistingError;

        //Verify Error is not udenfined
        if (!(typeof this.Errors !== 'undefined' && this.Errors.length > 0)) {
            this.Errors = [];
        }

        //Verify if the error exists
        findExistingError = this.Errors.find(err => err.code === errorCode && err.position === error.position);

        //If no error code found in the list, then add to the error list
        if (!(typeof findExistingError !== 'undefined' && findExistingError.code.length > 0)) {
            this.Errors.push(error);
            this.allSchedule[position].error = error;
        }
    }

    validatePickupTypeNeeded() {
        let errorPickupNeeded = new ErrorSchedule();
        if (this.pickupTypeSelectedValue == '-1') {
            errorPickupNeeded.message = this._translate.transform('upplm.pickupdetails.error.picktype_1');
            errorPickupNeeded.code = 'PICK_TYPE_11';
            errorPickupNeeded.position = -1;
            errorPickupNeeded.id = "pickupNeeded";

            let findExistingError = this.Errors.find(err => err.code === errorPickupNeeded.code);
            //If no error code found in the list, then add to the error list
            if (!(typeof findExistingError !== "undefined" && findExistingError.code.length > 0)) {
                this.Errors.push(errorPickupNeeded);
            }
        }
    }

    validateScheduleDSP(position: number) {
        let result = 0;
        this.Errors = this.removeFixedErrors(position);

        let daySelector = this.allSchedule[position].selectedDay ? "1" : "0";
        let preferred =
            this.allSchedule[position].preferredSelected != "-1" ? "1" : "0";
        let latest =
            this.allSchedule[position].latestSelected != "-1" ? "1" : "0";
        let saturday =
            this.allSchedule[position].shortDay == CommonConstants.SHORT_ORDERED_DAYS_OF_WEEK[5]
                ? "1"
                : "0";//If user select a DDL on saturday row
        let option = daySelector.concat(preferred, latest, saturday);
        let businessDays = this.allSchedule.filter(
            x => x.day !== CommonConstants.ORDERED_DAYS_OF_WEEK[5]
        );
        let selectedDays = businessDays.filter(x => x.selectedDay === true);

        let valDays: any = selectedDays.filter(x => x.day === this.allSchedule[position].day);

        if (selectedDays.length >= 1 && selectedDays.length <= 4 && (daySelector == '0' && preferred !== '0' && latest !== '0' && valDays > 0)) {
            return 0;
        }

        if (this.allSchedule[position].shortDay == CommonConstants.SHORT_ORDERED_DAYS_OF_WEEK[5] && this.allSchedule[position].selectedDay == true && selectedDays.length < 1) {
            this.addToListError("DSP_16", position);
            return 0;
        }

        switch (option) {
            case "1110":
            case "1111":
                return this.validateOneHourDifference(
                    this.allSchedule[position].preferredSelected,
                    this.allSchedule[position].latestSelected
                );
            case "0100":
                this.addToListError("DSP_11", position);
                break;
            case "0000":
                this.addToListError("DSP_3", position);
                break;
            case "1011":
                this.addToListError("DSP_4", position);
                break;
            case "1101":
                this.addToListError("DSP_5", position);
                break;
            case "1001":
                this.addToListError("DSP_6", position);
                break;
            case "1010":
                this.addToListError("DSP_7", position);
                break;
            case "1100":
                this.addToListError("DSP_8", position);
                break;
            case "1000":
                this.addToListError("DSP_9", position);
                break;

            case "0110":
                this.addToListError("DSP_10", position);
                break;
            case "0010":
                this.addToListError("DSP_12", position);
                break;
            case "0111":
                this.addToListError("DSP_13", position);
                break;
            case "0101":
                this.addToListError("DSP_14", position);
                break;
            case "0011":
                this.addToListError("DSP_15", position);
                break;
            default:
                return 0;
        }
        return result;
    }

    hasSaturday(availableDays: AvailableDayAndService[]): boolean {
        if (this.availableDaysAndServices.some(x => x.dayOfWeekCode === DAY_OF_WEEK.SATURDAY)) return true;
        return false;
    }

    activateSaturdayChk(event: Event) {
        this.includeSaturdayInPickup = (<HTMLInputElement>event.target).checked;
        this.getSchedulesByPickupType(this.pickupTypeSelectedValue, this.isSaturdayAvailable);
    }

    getSchedulesByPickupType(pickupType: string, hasSaturday: boolean) {
        let saturday = this.includeSaturday(this.isSaturdayAvailable, this.includeSaturdayInPickup);
        if (this.pickupTypeSelectedValue === PICKUP_TYPE.DAP || this.pickupTypeSelectedValue === PICKUP_TYPE.SMP) {
            if (saturday) {
                this.getScheduleData(6, 6, 6);
            } else {
                this.getScheduleData(5, 5, 5);
            }
        }
        else if (this.pickupTypeSelectedValue === PICKUP_TYPE.DSP) {
            if (this.isSaturdayAvailable) {
                this.getScheduleData(6, 6, 6);
            }
            else {
                this.getScheduleData(5, 5, 5);
            }
        }

    }

    includeSaturday(saturdayAvailable: boolean, checkSelected: boolean): boolean {
        if (this.includeSaturdayInPickup) {
            if (this.isSaturdayAvailable) return true;
        } else {
            return false;
        }
        return false;
    }

    getScheduleData(days: number, preferredDrops: number, latestDrops: number) {

        let i = 1;
        let validationDapSmp = false;
        if (this.pickupTypeSelectedValue === PICKUP_TYPE.DAP || this.pickupTypeSelectedValue === PICKUP_TYPE.SMP) {
            if (this.validationSelectDapSmp && this.allSchedule !== undefined) {
                if (days === 5) {
                    i = days;
                    if (this.allSchedule.length === 6) {
                        this.allSchedule = this.allSchedule.slice(0, this.allSchedule.length - 1);
                        validationDapSmp = true;
                    }
                } else {
                    i = days;
                }
            } else {
                this.validationSelectDapSmp = true;
                this.allSchedule = [];
            }
        } else {
            this.allSchedule = [];
        }
        if (validationDapSmp) {
            return;
        }


        for (i; i <= days; i++) {

            let schedule: GenericSchedule = new GenericSchedule();
            let dayAndService: AvailableDayAndService;
            schedule.day = CommonConstants.ORDERED_DAYS_OF_WEEK[i - 1];
            schedule.shortDay = CommonConstants.SHORT_ORDERED_DAYS_OF_WEEK[i - 1];
            switch (i) {
                case 1:
                    dayAndService = this.availableDaysAndServices.filter(x => x.dayOfWeekCode === DAY_OF_WEEK.MONDAY)[0];
                    break;
                case 2:
                    dayAndService = this.availableDaysAndServices.filter(x => x.dayOfWeekCode === DAY_OF_WEEK.TUESDAY)[0];
                    break;
                case 3:
                    dayAndService = this.availableDaysAndServices.filter(x => x.dayOfWeekCode === DAY_OF_WEEK.WEDNESDAY)[0];
                    break;
                case 4:
                    dayAndService = this.availableDaysAndServices.filter(x => x.dayOfWeekCode === DAY_OF_WEEK.THURSDAY)[0];
                    break;
                case 5:
                    dayAndService = this.availableDaysAndServices.filter(x => x.dayOfWeekCode === DAY_OF_WEEK.FRIDAY)[0];
                    break;
                case 6:
                    dayAndService = this.availableDaysAndServices.filter(x => x.dayOfWeekCode === DAY_OF_WEEK.SATURDAY)[0];
                    break;
            }
            schedule.dayOfWeekCode = dayAndService.dayOfWeekCode;

            if (i <= preferredDrops) {
                schedule.preferredTime = this.getScheduleList(dayAndService.preferredTime.startTime, dayAndService.preferredTime.endTime);
            }
            if (i <= latestDrops) {
                schedule.latestTime = this.getScheduleList(dayAndService.latestTime.startTime, dayAndService.latestTime.endTime);
            }
            schedule.latestSelected = "-1";
            schedule.preferredSelected = "-1";
            this.allSchedule.push(schedule);
        }
    }

    getScheduleList(startTime: string, endTime: string) {
        let scheduleList = [];
        let myScheduleListDDL = [];
        let currentProcesingTime: Date = this.getDateValueFromString(startTime);
        let nextTimeToProcess: Date = currentProcesingTime;
        let initialValue: boolean = true;
        let hour: number;
        let minute: number;
        let finalTime: Date = this.getDateValueFromString(endTime);

        while (this.evaluateDate(nextTimeToProcess, finalTime)) {

            currentProcesingTime = nextTimeToProcess;
            hour = Number(currentProcesingTime.getHours());
            minute = Number(currentProcesingTime.getMinutes());
            if (!initialValue) {
                scheduleList.push((hour < 10 ? `0${hour.toString()}:` : `${hour.toString()}:`).toString().toString().concat(minute < 10 ? `0${minute.toString()}` : `${minute.toString()}`)); //Insert in the array if it's a valid time
            }
            else {//Always insert the fist time of the schedule result
                /*scheduleList.push(startTime);*/
                scheduleList.push((hour < 10 ? `0${hour.toString()}:` : `${hour.toString()}:`).toString().toString().concat(minute < 10 ? `0${minute.toString()}` : `${minute.toString()}`));
                initialValue = false;
            }

            //Take the last value inserted in the time array to evaluate if it's a valid time
            let splitLastTime = scheduleList[scheduleList.length - 1].split(':');
            let lasthour = Number(splitLastTime[0]);
            let lastminute = Number(splitLastTime[1]);

            finalTime = this.getDateValueFromString(endTime); //Ensure always the finaltime is older (milliseconds are taken when calculates difference)
            //Increment the next time to evaluate
            nextTimeToProcess = this.getDateValueFromString(this.convertAndincrementHour(lasthour, lastminute).toString());
        }

        for (var i = 0; i < scheduleList.length; i++) {
            let oScheduleList: ScheduleListDDL = new ScheduleListDDL();
            oScheduleList.unformattedTime = scheduleList[i].toString();
            oScheduleList.formattedTime = this._commonService.formatAMPM(scheduleList[i].toString());
            myScheduleListDDL.push(oScheduleList);
        }
        return myScheduleListDDL;
    }

    getDateValueFromString(timeToConvert: string): Date {
        let convertedDate = new Date();
        let timeValues = timeToConvert.split(':');
        let hourValue = Number(timeValues[0]);
        let minuteValue = Number(timeValues[1]);
        convertedDate.setHours(hourValue);
        convertedDate.setMinutes(minuteValue);
        return convertedDate;
    };

    evaluateDate(dateToEvaluate1: Date, dateToEvaluate2: Date) {//Return True if initial is Grater than final
        let result = false;
        if (dateToEvaluate1.getHours() === 0) {
            return false;
        }
        if (dateToEvaluate1.getTime() <= dateToEvaluate2.getTime()) {
            result = true;
        }
        return result;
    };

    //Given an hour and minute, calculate the time lapse and returns a valid hour in string format
    convertAndincrementHour(hour: number, minute: number): string {
        let strTime: string = '';
        let timeToIncrease = LAPSE_TIME_INCREMENT * 60000; //Time to increase in milliseconds
        let dateTime = new Date(); //Create date from provided hour

        //set the provided hour and minute
        dateTime.setHours(hour);
        dateTime.setMinutes(minute);
        let calculatedDate = new Date(dateTime.getTime() + timeToIncrease); //Calcuate the sum of time + increase time
        strTime = calculatedDate.getHours().toString().concat(':', calculatedDate.getMinutes() < 10 ? '0' + calculatedDate.getMinutes().toString() : calculatedDate.getMinutes().toString());
        return strTime;
    }

    disableLatestTimes(schedule: GenericSchedule) {
        if (schedule.preferredSelected === "-1") {
            return;
        }
        schedule.latestTime.forEach((DDL) => {
            let result = this.validateOneHourDifference(schedule.preferredSelected, DDL.unformattedTime);
            DDL.isdisabled = result != 0 ? true : false;
        });
    }

    //Return 1 if Preferred Time is not an hour before Latest Time or Preferred > Latest
    //Return 2 if Latest Time is not an hour after Earliest Time
    //Return 0 if no error
    validateOneHourDifference(preferredHour: string, latestHour: string) {

        let result: number = 0;
        let preferredDate = new Date();
        let latestDate = new Date();

        let preferredValues = preferredHour.split(':');
        let preferredHourValue = Number(preferredValues[0]);
        let preferredMinuteValue = Number(preferredValues[1]);

        let latestValues = latestHour.split(':');
        let latestHourValue = Number(latestValues[0]);
        let latestMinuteValue = Number(latestValues[1]);

        preferredDate.setHours(preferredHourValue);
        preferredDate.setMinutes(preferredMinuteValue);

        latestDate.setHours(latestHourValue);
        latestDate.setMinutes(latestMinuteValue);

        let diffLatestMinusPreferred = (latestDate.getTime() - preferredDate.getTime()) / 1000;
        diffLatestMinusPreferred /= (60 * 60);

        if (preferredDate.getTime() > latestDate.getTime()) {
            result = 1;
        }
        else if (diffLatestMinusPreferred < 1) {
            result = 2;
        }
        else {
            result = 0;
        }

        return result;
    }
    // Rule for validation
    validPickupTypeSelected(control: AbstractControl): { [key: string]: boolean } | null {
        let value = control.value.toString().trim();
        if (value === '-1') return { 'valid': false };
        return null;
    }

    onSelectDay(val: any, index: number) {
        this.validateBusinessDays();
    }

    hideNotificationChange(showNotificationComponent: boolean) {
        this.showNotificationComponent(showNotificationComponent);
        if (this._storedDataService.isEditionComplete) {
            this.cancel();
        } else {
            //Load with session data
        }
    }

    showNotificationComponent(show: boolean) {
        this.showNotificationChanges = show;
        this.showEditPickupDetails = !show;
    }

    closeErrorMessageServerModal() {
        this.errorServerMessage.close();
    }
}

